import React from "react";
import { Container } from "../../../../components";
import classnames from "classnames";
import Pages from "../../../../../../constants/pages";
import TEXT from "../../../text-consts";
import BackLink from "../../atoms/BackLink/BackLink";
import CustomerContinueButton from "../../organisms/CustomerContinueButton/CustomerContinueButton";
import { isBankIdVerified } from "../../../../authentication/state/selectors";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../models";
import PersonalDetailsContinueButton from "../../organisms/PersonalDetailsContinueButton/PersonalDetailsContinueButton";
import { FWA_LINKS } from "../../../../../../constants";

interface ContinueButtonProps {
    path: string;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({ path }) => {
    const bankIdVerified = useSelector((state: RootState) => isBankIdVerified(state));

    switch (path) {
        case Pages.FWA.CUSTOMER.URL:
            return bankIdVerified ? <CustomerContinueButton /> : null;
        case Pages.FWA.PERSONAL_DETAILS.URL:
            return <PersonalDetailsContinueButton />;
        default:
            return null;
    }
};

interface BackButtonProps {
    path: string;
}

const BackButton: React.FC<BackButtonProps> = ({ path = "" }) => {
    let href = "";
    let text = TEXT.BUTTON.BACK;
    const currentIndex = FWA_LINKS.findIndex((link) => path.includes(link));

    if (path.includes(Pages.FWA.RECEIPT.URL)) {
        href = "https://www.telia.no/";
        text = TEXT.BUTTON.TELIANO_PAGE;
    } else if (currentIndex > 0) {
        href = FWA_LINKS[currentIndex - 1];
    }

    return <BackLink path={path} href={href} text={text} />;
};

interface ContinueSectionProps {
    className?: string;
    path: string;
}

const ContinueSection: React.FC<ContinueSectionProps> = ({ className = "", path }) => (
    <Container
        className={classnames("fwa-page--space-between", {
            [className]: className,
        })}
        size="small"
        noMargin
    >
        <BackButton path={path} />
        <div className="fwa-page__continue-button-container">
            <ContinueButton path={path} />
        </div>
    </Container>
);

export default ContinueSection;
